import React, { Component } from 'react'
import { string, func, bool } from 'prop-types'
import classNames from 'classnames'

import Icon from 'components/uiElements/Icon'

require('./ActionButton.scss')

class ActionButton extends Component {
    constructor(props) {
        super(props)
        this.onClick = this.onClick.bind(this)
    }

    onClick(e) {
        if (this.props.onClick) {
            this.props.onClick(e)
        }
    }

    render() {
        const { active, code, children, disabled, type } = this.props
        return (
            <button
                className={classNames(`ActionButton ${type}`, { active, disabled })}
                onClick={this.onClick}
                disabled={disabled}
            >
                <div className="inner">
                    {code ? <Icon code={code} /> : null}
                    {children}
                </div>
            </button>
        )
    }
}
ActionButton.defaultProps = {
    onClick: null,
    active: false,
    code: null,
    children: null,
    disabled: false,
    type: '',
}
ActionButton.propTypes = {
    code: string,
    onClick: func,
    active: bool,
    children: string,
    disabled: bool,
    type: string,
}

export default ActionButton
